
export default {
  dashboard: 'Tablero',
  questionnaires: 'Cuestionarios',
  open_questions: 'Preguntas Abiertas',
  evaluations: 'Valoraciones',
  suite: 'Suite',
  logout: 'Cerrar sesión'
}
